// Lazy load function
const lazyLoad = (file) => () =>
    import(
    /* webpackChunkName: "[request]" */ `@/views/production/schedule/${file}.vue`
    );

export default [
    {
        path: "/production-calendar/:tab*",
        name: "production-calendar",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "ProductionSchedule",
        },
        components: {
            content: lazyLoad("production-calendar"),
        },
    },
];
